import {HTTPService} from '../../services/httpservice';
import {UserTypes} from './types';

export const logout = () => {
  return {
    type: UserTypes.LOGOUT
  }
}

export const adminLogin = data => {
  return {
    type: UserTypes.LOGIN,
    request: {
      path: HTTPService.LOGIN,
      method: 'POST',
      data,
    },
  };
};

export const getUserData = () => {
  return {
    type: UserTypes.GET_USER,
    request: {
      path: HTTPService.GET_USER ,
      method: 'GET',
    },
  };
};

export const setPassword = (id, data) => {
  const targetData = typeof id === "object" ? id : data;
  const targetId = typeof id === "string" ? id : "";
  const path = targetId ? `${HTTPService.SET_PASSWORD}/${targetId}` : HTTPService.SET_PASSWORD;
  return {
    type: UserTypes.GET_USER,
    request: {
      path,
      method: 'PUT',
      data: targetData,
    },
  };
};

